import { createContext } from 'react';

export interface IIdentityContext {
  roles: string[];
  isAdmin: boolean;
  isSupervisor: boolean;
  isElevated: boolean;
  identityLoaded: boolean;
}

export const IdentityContext = createContext<IIdentityContext>({
  roles: [],
  isAdmin: false,
  isSupervisor: false,
  isElevated: false,
  identityLoaded: false,
});
